export default __webpack_public_path__ + "static/media/create_form.804f145b.svg";